import { render, staticRenderFns } from "./TargetSelectModal.vue?vue&type=template&id=2ed36dce&lang=pug"
import script from "./TargetSelectModal.vue?vue&type=script&lang=ts"
export * from "./TargetSelectModal.vue?vue&type=script&lang=ts"
import style0 from "./TargetSelectModal.vue?vue&type=style&index=0&id=2ed36dce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports